export const IconBook = () => (
    <svg
        width={92}
        height={92}
        viewBox="0 0 92 92"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx={46} cy={46} r={46} fill="#DFF0FF" />
        <g clipPath="url(#clip0_1983_22160)">
            <g clipPath="url(#clip1_1983_22160)">
                <path
                    d="M58.8333 27.6667H35C32.789 27.6667 29.5 29.1315 29.5 33.1667V58.8333C29.5 62.8685 32.789 64.3333 35 64.3333H62.5V60.6667H35.022C34.175 60.6447 33.1667 60.311 33.1667 58.8333C33.1667 58.6482 33.1832 58.4832 33.2107 58.3328C33.416 57.2768 34.2813 57.0183 35.022 57H62.5V31.3333C62.5 30.3609 62.1137 29.4282 61.4261 28.7406C60.7384 28.053 59.8058 27.6667 58.8333 27.6667ZM58.8333 44.1667L55.1667 42.3333L51.5 44.1667V31.3333H58.8333V44.1667Z"
                    fill="#1890FF"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_1983_22160">
                <rect
                    width={44}
                    height={44}
                    fill="white"
                    transform="translate(24 24)"
                />
            </clipPath>
            <clipPath id="clip1_1983_22160">
                <rect
                    width={44}
                    height={44}
                    fill="white"
                    transform="translate(24 24)"
                />
            </clipPath>
        </defs>
    </svg>
);

export const IconLeft = () => (
    <svg
        width={8}
        height={59}
        viewBox="0 0 8 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 0C4.41828 0 8 3.58172 8 8V51C8 55.4183 4.41828 59 0 59V0Z"
            fill="#1890FF"
        />
    </svg>
);
